import {Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material';

@Component({
  selector: 'app-result-message',
  template: `
    <div align="center" class="col_yellow">
      <span>Result</span>
      <button aria-label="Close" class="close opacity_1_imp" type="button">
        <span aria-hidden="true" class="col_yellow"
              (click)="snackBarRef.dismiss()">×</span>
      </button>
    </div>
    <div class="padding_3" *ngFor="let res of data">
      <div class="bg-green border_radius_10 padding_0_5_imp">
        <span class="color-white">{{res?.defaultMessage}}</span>
      </div>
    </div>
  `
})
export class ResultMessageComponent implements OnInit {

  constructor(public snackBarRef: MatSnackBarRef<ResultMessageComponent>,
              @Inject(MAT_SNACK_BAR_DATA) public data: any[]) {
  }

  ngOnInit() {
  }

}
